import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gengduo",
  "use": "icon-gengduo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gengduo\"><path d=\"M62.5 839.9c-37 0-57.5 24.7-57.5 57.5 0 37 24.7 57.5 57.5 57.5 37 0 57.5-24.7 57.5-57.5s-20.5-57.5-57.5-57.5zM966.5 445.5h-678c-37 0-57.5 28.8-57.5 57.5 0 37 28.8 57.5 57.5 57.5h678c32.9 0 53.4-24.7 57.5-57.5 0-37-28.8-57.5-57.5-57.5zM288.5 166.1h678c32.9 0 57.5-20.5 57.5-57.5s-28.8-57.5-57.5-57.5h-678c-37 0-57.5 28.8-57.5 57.5-0.1 36.9 28.7 57.5 57.5 57.5zM62.5 445.5C25.5 445.5 5 466 5 503s24.7 57.5 57.5 57.5c37 0 57.5-24.7 57.5-57.5 0-32.9-20.5-57.5-57.5-57.5zM62.5 51C25.5 51 5 75.7 5 108.5c0 37 24.7 57.5 57.5 57.5 37 0 57.5-24.7 57.5-57.5S99.5 51 62.5 51zM966.5 839.9h-678c-37 0-57.5 28.8-57.5 57.5 0 37 28.8 57.5 57.5 57.5h678c32.9 0 53.4-24.7 57.5-57.5 0-36.9-28.8-57.5-57.5-57.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gengduo.svg
// module id = wkfg
// module chunks = 73